import React, { useEffect, useState } from "react";

import { useGlobalValue } from "colbi_web_ui/lib/state/GlobalProvider";
import styles from "./Header.module.sass";
import {
    SovosToolbar,
    SovosToolbarActions,
    SovosMenuItem,
    SovosToolbarDropdown,
    SovosTypography,
    SovosTab,
    SovosTabs,
} from "mosaic-react";

import SovosMonthSelector from "colbi_web_ui/lib/components/layout/YearSelector/index.js";
import { regexURLMatcher } from "colbi_web_ui/lib/utils/routingUtils.js";
import { hasModule, sanitizeErrorForLogging } from "../../../utils/utils";
const Header = (props) => {
    const {
        getRawTablesAvailable,
        fiscalYears,
        importIds,
        rawDataModules,
        viewMode: viewModeProp,
        onViewModeChange,
        modules
    } = props;
    const hasNewNavigation = hasModule(modules, "new_navigation");
    // Use viewMode from prop, default to "source"
    const viewMode = viewModeProp || "source";

    const handleViewModeChange = (newValue) => {
        if (onViewModeChange && typeof onViewModeChange === "function") {
            onViewModeChange(newValue);
        }
    };
    const { history, params, i18n } = useGlobalValue();
    const { projectId, modulePrefix, fiscalYear } = params;
    const effectiveModulePrefix = (hasModule(rawDataModules, modulePrefix) && modulePrefix) || (rawDataModules && rawDataModules[0]) || "";
    const [arrayImportIds, setArrayImportIds] = useState([]);
    const [currentFile, setCurrentFile] = useState("");
    const [currentFiscalYears, setCurrentFiscalYears] = useState([]);
    const [selectedYear, setSelectedYear] = useState(null);
    useEffect(() => {
        if (!effectiveModulePrefix) return;
        getRawTablesAvailable(projectId, effectiveModulePrefix, fiscalYear)
            .then((res) => {
                const { tables_available } = res;
                setArrayImportIds(tables_available || []);
            })
            .catch((error) => {
                console.error(sanitizeErrorForLogging(error)); // eslint-disable-line no-console
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [projectId, effectiveModulePrefix, fiscalYear]);

    useEffect(() => {
        if (fiscalYears && typeof fiscalYears === "object") {
            const yearsArray = Object.keys(fiscalYears).map((year) => parseInt(year));
            setCurrentFiscalYears(yearsArray);
        }
    }, [fiscalYears]);

    useEffect(() => {
        if (history?.location) {
            const myRegex1 =
                /^(\/(pt|en|lt|es|ro|fr)\/\d+\/)(\d{4}|current)\/?(\d+|full)?(\/.*\/)?([^/]+)?$/;

            const match = regexURLMatcher(myRegex1, history?.location?.pathname || "");
            if (match) {
                const group4 = match[4];
                const group6 = match[6];
                if (group4 && group6) {
                    setCurrentFile(`${group4} - ${group6}`);
                }

                const group3 = match[3];
                setSelectedYear(+group3);
            }
        }
        // eslint-disable-next-line
    }, [JSON.stringify(history)]);

    return (
        <div key="mainDiv">
            <div className={`${styles["header-root"]}`}>
                {Array.isArray(importIds) && (
                    <div className={`${styles["toolbar-container"]}`}>
                        <div className={`${styles["view-toggle"]}`} role="tablist" aria-label="View mode selector">
                            {hasNewNavigation ?
                                <SovosTabs
                                    value={viewMode}
                                    onChange={(_, newValue) => handleViewModeChange(newValue)}
                                >
                                    <SovosTab value="source" label={i18n`Source`} />
                                    <SovosTab value="legal" label={i18n`Legal`} />
                                </SovosTabs>
                                :
                                null
                            }
                        </div>
                        <SovosMonthSelector
                            className={`${styles["sovos-month-selector"]}`}
                            format={"number"}
                            selectedYear={+selectedYear}
                            nextMonthTooltipText={"Next"}
                            previousMonthTooltipText={"Previous"}
                            years={currentFiscalYears}
                            minDate={new Date(`${currentFiscalYears[0]}-01-01`)}
                            maxDate={
                                new Date(
                                    `${currentFiscalYears[currentFiscalYears.length - 1]}-12-31`,
                                )
                            }
                            onChange={(e) => {
                                const newYear = e.year;
                                const currentData = fiscalYears[newYear];
                                let lastImportId;
                                if (Array.isArray(currentData)) {
                                    let fiscalYearIds = currentData.map((item) => item.id);

                                    lastImportId =
                                        fiscalYearIds.indexOf("full") !== -1
                                            ? "full"
                                            : Math.max(...fiscalYearIds);
                                }
                                const myRegex =
                                    /^(\/(pt|en|lt|es|ro|fr)\/\d+\/)(\d{4}|current)\/?(\d+|full)?(\/*.*)/;

                                const match = regexURLMatcher(myRegex, history.location.pathname);
                                if (match?.[4]) {
                                    history.push(
                                        history.location.pathname.replace(
                                            myRegex,
                                            `$1${newYear}/${lastImportId}$5`,
                                        ),
                                    );
                                } else {
                                    history.push(
                                        history.location.pathname.replace(
                                            myRegex,
                                            `$1${newYear}/$5`,
                                        ),
                                    );
                                }
                            }}
                        />
                        <SovosToolbar className={`${styles["sovos-toolbar-config"]}`}>
                            <SovosToolbarActions className={`${styles["sovos-toolbar-config"]}`}>
                                <SovosToolbarDropdown
                                    className={`${styles["toolbar-dropdown-config"]}`}
                                    value={effectiveModulePrefix}
                                    onChange={(event) => {
                                        const myRegex = new RegExp(
                                            `^(\\/(pt|en|lt|es|ro|fr)\\/\\d+\\/)(\\d{4}|current)\\/(\\d+|full)\\/(${rawDataModules.join(
                                                "|",
                                            )})?(\\/*.*)`,
                                        );
                                        const newHistory = history.location.pathname.replace(
                                            myRegex,
                                            `$1$3/$4/${event.target.value}$6`,
                                        );

                                        history.push(newHistory);
                                    }}
                                >
                                    {(rawDataModules || []).map((config, id) => (
                                        <SovosMenuItem key={id} value={config}>
                                            {config}
                                        </SovosMenuItem>
                                    ))}
                                </SovosToolbarDropdown>
                            </SovosToolbarActions>
                        </SovosToolbar>
                        <SovosToolbar className={`${styles["sovos-toolbar"]}`}>
                            <SovosToolbarActions className={`${styles["toolbar-actions"]}`}>
                                <SovosToolbarDropdown
                                    className={`${styles["toolbar-dropdown"]}`}
                                    value={currentFile}
                                    onChange={(event) => {
                                        const selectedValue = event.target.value;

                                        // Verificar se o valor existe e contém o formato esperado
                                        if (!selectedValue || typeof selectedValue !== 'string' || !selectedValue.includes('-')) {
                                            return; // Não fazer nada se o valor for inválido
                                        }

                                        setCurrentFile(selectedValue);
                                        const parts = selectedValue.split("-");
                                        const importIdFromTable = parts[0].trim();
                                        const fileType = parts[1].trim();

                                        // Check if we're on the landing page (/data/raw)
                                        const isLandingPage = /\/data\/raw\/?$/.test(history.location.pathname);
                                        if (isLandingPage) {
                                            // Navigate from landing page to raw_data view with module prefix
                                            const baseRegex = /^(\/(pt|en|lt|es|ro|fr)\/\d+\/)(\d{4}|current)\/(\d+|full)\/data\/raw\/?$/;
                                            const newHistory = history.location.pathname.replace(
                                                baseRegex,
                                                `$1$3/${importIdFromTable}/${effectiveModulePrefix}/raw_data/${fileType}`,
                                            );
                                            history.push(newHistory);
                                        } else {
                                            // Standard navigation within raw_data view
                                            const myRegex =
                                                /^(\/(pt|en|lt|es|ro|fr)\/\d+\/)(\d{4}|current)\/(\d+|full)\/(.*\/)?(\/*.*)/;
                                            const newHistory = history.location.pathname.replace(
                                                myRegex,
                                                `$1$3/${importIdFromTable}/$5${fileType}`,
                                            );
                                            history.push(newHistory);
                                        }
                                    }}
                                >
                                    {arrayImportIds?.length ? (
                                        arrayImportIds.map((name) => {
                                            const splitName = name.split("-");
                                            const translatedImportId = splitName[0]
                                                .trim()
                                                .replace(/full/gm, "Full");
                                            return (
                                                <SovosMenuItem key={name} value={name}>
                                                    {`${translatedImportId} - ${splitName[1]}`}
                                                </SovosMenuItem>
                                            );
                                        })
                                    ) : (
                                        <SovosTypography
                                            sx={{
                                                padding: "5px",
                                                pointerEvents: "none",
                                                color: "text.secondary"
                                            }}
                                        >{i18n`No options available`}</SovosTypography>
                                    )}
                                </SovosToolbarDropdown>
                            </SovosToolbarActions>
                        </SovosToolbar>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Header;
